import { Controller } from 'stimulus';
import validatePostcode, { INVALID_POSTCODE } from '../utils/validate_postcode';

export default class extends Controller {
  get shouldReportValidity() {
    return this.data.get('report') === 'enabled';
  }

  async validate(event) {
    event.stopImmediatePropagation();
    event.preventDefault();

    const inputElement = event.target;
    const postcode = inputElement.value;

    const isValid = await validatePostcode(postcode);

    if (isValid) {
      const validPostcodeEvent = new Event('validPostcode');
      inputElement.setCustomValidity('');
      inputElement.dispatchEvent(validPostcodeEvent);
      return;
    }

    inputElement.setCustomValidity(INVALID_POSTCODE);
    if (this.shouldReportValidity) {
      inputElement.reportValidity();
    }
  }
}
